export default __webpack_public_path__ + "static/media/Saved to profile.8ee875d8.png";